export default __webpack_public_path__ + "static/media/picture_jion_banner.1747a219.png";